export default __webpack_public_path__ + "static/media/bowie_main.285a0d3d.webp";